module.exports = __webpack_public_path__ + "img/horizontal.38bb6fb5.png";